<template>
  <v-container px-0 :class="{'grid-list-md': isMobile, 'grid-list-lg': !isMobile}">
    <v-form ref="serviceInformation">
      <v-layout row wrap>
        <!--provider name-->
        <v-flex xs12 sm6 md6>
          <v-text-field
            v-model="providerNameCheck"
            label="Provider"
            readonly>
          </v-text-field>
        </v-flex>
        <!--provider credentials-->
        <v-flex xs12 sm6 md6>
          <v-text-field
            v-model="student.form.serviceInformation.credentialName"
            placeholder="—"
            readonly>
            <template slot="label">
              <span v-if="isMobile">Credentials</span>
              <span v-else>Provider Credentials</span>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <!--service date picker-->
        <v-flex :class="{'xs12 sm6 md6' : providerAbsent, 'xs12 sm4 md4' : (!hideFields || studentAbsent)}">
          <v-menu
            ref="serviceMenu"
            :close-on-content-click="true"
            v-model="serviceMenu"
            :nudge-right="40"
            :return-value.sync="serviceDate"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px">
            <v-text-field
              :error-messages="sessionDateErrors"
              slot="activator"
              v-model="student.form.serviceInformation.sessionDate"
              label="Service Date"
              placeholder="Select a Service Date"
              readonly>
            </v-text-field>
            <v-date-picker
              v-model="serviceDate"
              :allowedDates="allowedDates"
              no-title
              scrollable
              @change="serviceDateChanged(serviceDate)"
              @input="$refs.serviceMenu.save(serviceDate)">
            </v-date-picker>
          </v-menu>
        </v-flex>
        <!--Service Delivered-->
        <v-flex xs12 sm4 md4 v-if="!hideFields">
          <v-select
              :items="serviceDeliveredArray"
              :error-messages="serviceDeliveredErrors"
              item-text="name"
              item-value="value"
              label="Service Delivered"
              placeholder="Select Service Delivered"
              v-model="student.form.serviceInformation.serviceDelivered"
              @change="serviceDeliveredChanged"
              @blur="v.serviceDelivered.$touch()">
          </v-select>
        </v-flex>
        <!--Student/Provider not available (absent type)-->
        <v-flex :class="{'xs12 sm6 md6' : providerAbsent, 'xs12 sm4 md4' : (!hideFields || studentAbsent)}">
          <v-select
            :items="absentTypesArray"
            :error-messages="absentTypeErrors"
            item-text="name"
            item-value="value"
            label="Student/Provider Not Available"
            placeholder="Select Student or Provider"
            v-model="student.form.serviceInformation.absentType"
            clearable
            @change="absentTypeChanged"
            @blur="v.absentType.$touch()">
          </v-select>
        </v-flex>
        <!--Reason Student not available-->
        <v-flex xs12 sm4 md4 v-if="studentAbsent">
          <v-select
            :items="absentReasonsArray"
            item-text="name"
            item-value="value"
            label="Reason Student Not Available"
            placeholder="Select Why Student is Not Available"
            v-model="student.form.serviceInformation.absentReason"
            :error-messages="absentReasonErrors"
            @blur="v.absentReason.$touch()">
          </v-select>
        </v-flex>
        <!--Service Alternative (provider absent)-->
        <v-flex xs12 sm6 md6 v-if="providerAbsent">
          <v-select
            :items="absentAlternativesArray"
            item-text="name"
            item-value="value"
            label="Service Alternative"
            placeholder="Select Service Alternative"
            v-model="student.form.serviceInformation.absentAlternative"
            :error-messages="absentAltErrors"
            @blur="v.absentAlternative.$touch()">
          </v-select>
        </v-flex>
        <!-- Parents Informed (when no provider absent alternative provided)-->
        <v-flex xs12 sm6 md6 v-if="providerAbsent && notAltService">
          <v-select
            :items="noServiceProvidedOptions"
            item-text="name"
            item-value="value"
            label="Parents Informed?"
            placeholder="Select Yes or No"
            v-model="student.form.serviceInformation.noServiceNotifFlag"
            :error-messages="noServiceNotifErrors"
            @blur="v.noServiceNotifFlag.$touch()">
          </v-select>
        </v-flex>
        <!-- Alternate Description (when provider absent alternative provided)-->
        <v-flex xs12 sm6 md6 v-if="providerAbsent && altService">
          <v-text-field
            label="Alternate Description"
            placeholder="Enter Alternate Description"
            v-model="student.form.serviceInformation.absentAlternativeDesc"
            counter
            maxlength="30"
            :error-messages="absentAltDescErrors"
            @blur="handleTextTrimmingRequiredField('absentAlternativeDesc', student.form.serviceInformation.absentAlternativeDesc)">
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <!--start time picker-->
        <v-flex xs12 sm4 md4 v-if="!hideFields">
          <v-text-field
            :error-messages="sessionTimeErrors"
            v-model="student.form.serviceInformation.sessionTime"
            @blur="startTimeChanged"
            label="Start Time"
            type="time">
            <template slot="prepend">
              <v-dialog
                ref="startTimeDialog"
                v-model="startTimeModal"
                lazy
                full-width
                width="290px">
                <v-icon slot="activator">access_time</v-icon>
                <v-time-picker
                  v-if="startTimeModal"
                  v-model="student.form.serviceInformation.sessionTime"
                  full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="startTimeModal = false">Cancel</v-btn>
                  <v-btn flat color="primary"
                         @click="startTimeChanged">
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog>
            </template>
          </v-text-field>
        </v-flex>
        <!--end time picker-->
        <v-flex xs12 sm4 md4 v-if="!hideFields">
          <v-text-field
            :error-messages="sessionTimeEndErrors"
            v-model="student.form.serviceInformation.sessionTimeEnd"
            @blur="endTimeChanged"
            label="End Time"
            type="time">
            <template slot="prepend">
              <v-dialog
                ref="endTimeDialog"
                v-model="endTimeModal"
                lazy
                full-width
                width="290px">
                <v-icon slot="activator">access_time</v-icon>
                <v-time-picker
                  v-if="endTimeModal"
                  v-model="student.form.serviceInformation.sessionTimeEnd"
                  full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="endTimeModal = false">Cancel</v-btn>
                  <v-btn flat color="primary"
                         @click="endTimeChanged">
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog>
            </template>
          </v-text-field>
        </v-flex>
        <!--service length-->
        <v-flex xs12 sm4 md4 v-if="!hideFields">
          <v-text-field
            v-model="student.form.serviceInformation.sessionMinutes"
            label="Service Length (mins)"
            placeholder="Enter Service Length"
            :error-messages="serviceLengthErrors"
            @blur="sessionMinutesChanged"
            type="number"
            required>
          </v-text-field>
        </v-flex>
        <!--location-->
        <v-flex :class="{'xs12 sm6 md3' : (!hideFields && showGroup), 'xs12 sm6 md6' : (hideFields && showGroup), 'xs12 sm4 md4' : (!hideFields && !showGroup), 'xs12 sm4 md4' : (hideFields && !showGroup)}">
          <v-combobox
            dense
            label="Location"
            placeholder="Enter Location"
            :items="locationsArray"
            :loading="locationsLoading"
            v-model="student.form.serviceInformation.location"
            :clearable="true"
            item-text="locationName"
            :return-object="true"
            :search-input.sync="searchInput"
            :error-messages="locationErrors"
            @blur="v.location.$touch()"
            @change="v.location.$touch()"
            @focus="clearLocationsAutoComplete"
            :no-filter="true">
            <template slot="no-data">
              <v-list>
                <v-list-tile v-if="!searchInput">
                  Please type a Location.
                </v-list-tile>
                <v-list-tile
                  v-if="searchInput && !locationsLoading">
                  No Results
                </v-list-tile>
              </v-list>
            </template>
          </v-combobox>
        </v-flex>
        <!--location details-->
        <v-flex :class="{'xs12 sm6 md3' : (!hideFields && showGroup), 'xs12 sm6 md6' : (hideFields && showGroup), 'xs12 sm4 md4' : (!hideFields && !showGroup), 'xs12 sm4 md4' : (hideFields && !showGroup)}">
          <v-text-field
            label="Location Details"
            placeholder="Enter Location Details"
            v-model="student.form.serviceInformation.locationOther"
            counter
            maxlength="30"
            @blur="handleTextTrimming('locationOther', student.form.serviceInformation.locationOther)">
          </v-text-field>
        </v-flex>
        <!--group type-->
        <v-flex xs12 sm6 md3 v-if="!hideFields && showGroup">
          <v-select
            :items="groupTypeArray"
            item-text="name"
            item-value="value"
            label="Group Type"
            placeholder="Select Group Type"
            v-model="student.form.serviceInformation.groupType"
            @change="groupTypeChanged">
          </v-select>
        </v-flex>
        <!--group size-->
        <v-flex :class="{'xs12 sm6 md3' : showGroup, 'xs12 sm6 md4' : !showGroup}" v-if="!hideFields">
          <v-text-field
            v-model="student.form.serviceInformation.groupSize"
            label="Group Size"
            placeholder="Enter Group Size"
            :error-messages="groupSizeErrors"
            @blur="v.groupSize.$touch()"
            type="number"
            required>
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <!-- delivery mode -->
        <v-flex xs12 sm6 md5 v-if="!hideFields">
          <v-select
              :items="filterDisabledOptions(deliveryModeArray, student.form.serviceInformation.deliveryMode)"
              :error-messages="deliveryModeErrors"
              item-text="name"
              item-value="value"
              label="Delivery Mode"
              placeholder="Select Delivery Mode"
              v-model="student.form.serviceInformation.deliveryMode"
              @blur="v.deliveryMode.$touch()">
          </v-select>
        </v-flex>
        <!--classroom name/number-->
        <v-flex xs12 sm6 md5 v-if="!hideFields && !hideRoomField">
          <v-text-field
              label="Classroom Number"
              placeholder="Enter Classroom Number"
              v-model="student.form.serviceInformation.roomName"
              counter
              maxlength="30"
              @blur="handleTextTrimming('roomName', student.form.serviceInformation.roomName)">
          </v-text-field>
        </v-flex>
        <!-- Provider Location -->
        <v-flex xs12 sm6 md5 v-if="!hideFields && !hideProviderLocationField">
          <v-text-field
              label="Provider Location"
              placeholder="Enter Provider Location"
              v-model="student.form.serviceInformation.providerLocation"
              counter
              maxlength="30"
              :error-messages="providerLocationErrors"
              @blur="handleTextTrimmingRequiredField('providerLocation', student.form.serviceInformation.providerLocation)">
          </v-text-field>
        </v-flex>
      </v-layout>
      <!--comments-->
          <v-textarea
            label="Comments"
            placeholder="Enter Comments"
            counter
            maxlength="155"
            v-model="student.form.serviceInformation.notes"
            @blur="handleTextTrimming('notes', student.form.serviceInformation.notes)">
          </v-textarea>
    </v-form>
  </v-container>
</template>

<script>
import * as _ from 'lodash';
import * as moment from 'moment';
import api from '@/utils/api';
import utilityFunctions from '@/utils/functions';
import * as Constants from '@/constants';

export default {
  /* eslint-disable */
  name: 'ServiceInformation',
  props: ['student', 'showTooltip', 'absentTypesArray', 'absentReasonsArray', 'absentAlternativesArray', 'groupTypeArray', 'deliveryModeArray', 'serviceDeliveredArray', 'supervisorFlagsArray', 'action', 'validateForm', 'v'],
  data() {
    return {
      // service date display controls
      serviceMenu: false,
      serviceDate: null,
      // start time display controls
      startTimeDialog: false,
      startTimeModal: '',
      // end time display controls
      endTimeDialog: false,
      endTimeModal: '',
      hideFields: false,
      studentAbsent: false,
      providerAbsent: false,
      showGroup: false,
      hideRoomField: true,
      hideProviderLocationField: true,
      searchInput: null,
      locationsArray: [],
      locationsLoading: false,
      sessionTime: null,
      sessionTimeEnd: null,
      noServiceProvidedOptions: [
        { name: 'Yes', value: true },
        { name: 'No', value: false }
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    isEditingOrCopying() {
      return this.action === 'edit' || this.action === 'copy';
    },
    absentTypeErrors() {
      const errors = [];
      const absentType = this.v.absentType;
      if (!absentType || !absentType.$dirty) return errors;
      return errors;
    },
    absentReasonErrors() {
      const errors = [];
      const absentReason = this.v.absentReason;
      if (!absentReason || !absentReason.$dirty) return errors;
      if (!absentReason.required) errors.push('Student Absent Reason is required.');
      return errors;
    },
    absentAltErrors() {
      const errors = [];
      const absentAlternative = this.v.absentAlternative;
      if (! absentAlternative || !absentAlternative.$dirty) return errors;
      if (!absentAlternative.required) errors.push('Service Alternative is required.');
      return errors;
    },
    noServiceNotifErrors() {
      const errors = [];
      const noServiceFlag = this.v.noServiceNotifFlag;
      if (!noServiceFlag || !noServiceFlag.$dirty) return errors;
      if (!noServiceFlag.required) errors.push('Parents Informed is required.');
      return errors;
    },
    absentAltDescErrors() {
      const errors = [];
      const absentAlternativeDesc = this.v.absentAlternativeDesc;
      if (!absentAlternativeDesc || !absentAlternativeDesc.$dirty) return errors;
      if (!absentAlternativeDesc.required) errors.push('Alternate Description is required.');
      return errors;
    },
    sessionDateErrors() {
      const errors = [];
      const sessionDate = this.v.sessionDate;
      if (!sessionDate.$dirty) return errors;
      if (!sessionDate.required) errors.push('Service Date is required.');
      if (!sessionDate.isWithinOneYear) errors.push('Service Date must be within one year.');
      if (!sessionDate.isBetweenStartAndEndDate) errors.push('Service Date must be between Projected Start Date and Projected End Date.');
      if (!sessionDate.isNotFutureDate) errors.push('Service Date cannot be a future date.');
      return errors;
    },
    sessionTimeErrors() {
      const errors = [];
      const startTime = this.v.sessionTime;
      if (!startTime || !startTime.$dirty) return errors;
      if (!startTime.required) errors.push('Please enter a valid time (hh:mm tt)');
      return errors;
    },
    sessionTimeEndErrors() {
      const errors = [];
      const endTime = this.v.sessionTimeEnd;
      if (!endTime || !endTime.$dirty) return errors;
      if (!endTime.required) errors.push('Please enter a valid time (hh:mm tt).');
      if (!endTime.isSessionTimeEndGreaterThanSessionTime) errors.push('End Time must be greater than Start Time');
      return errors;
    },
    serviceLengthErrors() {
      const errors = [];
      const serviceLength = this.v.sessionMinutes;
      if (!serviceLength || !serviceLength.$dirty) return errors;
      if (!serviceLength.required) errors.push('Service Length is required.');
      if (!serviceLength.areMinutesGreaterThanZero) errors.push('Minutes must be greater than 0.');
      // validates service length doesnt exceed time in day
      // have it in component to show user how much time
      const startTime = this.student.form.serviceInformation.sessionTime ?
        utilityFunctions.convertTimeToMinutes(this.student.form.serviceInformation.sessionTime, true) : null;
      const val = this.student.form.serviceInformation.sessionMinutes;
      if (!_.isNil(startTime) && val) {
        const maxMinutes = 1440 - startTime;
        if (Number(val) > maxMinutes) errors.push(`Service Length cannot exceed ${maxMinutes} minutes.`);
      }
      if (!serviceLength.isValidMinutes) errors.push('Invalid minutes.');
      return errors;
    },
    locationErrors() {
      const errors = [];
      const location = this.v.location;
      if (!location.$dirty) return errors;
      if (!location.required) errors.push('Location is required.');
      return errors;
    },
    groupSizeErrors() {
      const errors = [];
      const groupSize = this.v.groupSize;
      if (! groupSize || !groupSize.$dirty) return errors;
      if (!groupSize.isValidGroupSize) errors.push('Group Size must be an integer greater than 0.');
      if (!groupSize.isValidLength) errors.push('Group Size must be less than 10 characters');
      return errors;
    },
    deliveryModeErrors() {
      const errors = [];
      const deliveryMode = this.v.deliveryMode;
      if (!deliveryMode.$dirty) return errors;
      if (!deliveryMode.required) errors.push('Delivery Mode is required.');
      return errors;
    },
    providerLocationErrors() {
      const errors = [];
      const providerLocation = this.v.providerLocation;
      if (!providerLocation.$dirty) return errors;
      if (!providerLocation.isProviderLocationRequired) errors.push('Provider Location is required.');
      return errors;
    },
    roomNameErrors() {
      const errors = [];
      const roomName = this.v.roomName;
      if (!roomName.$dirty) return errors;
      if (!roomName.required) errors.push('Classroom Number is required.');
      return errors;
    },
    notesErrors() {
      const errors = [];
      const notes = this.v.notes;
      if (!notes.$dirty) return errors;
      return errors;
    },
    providerNameCheck() {
      if(this.student.form.serviceInformation.providerFirstLastName !== 'undefined undefined') {
        return this.student.form.serviceInformation.providerFirstLastName;
      }
      else {
        return this.student.form.serviceInformation.fullName;
      }
    },
    serviceDeliveredErrors() {
      const errors = [];
      const serviceDelivered = this.v.serviceDelivered;
      if (!serviceDelivered || !serviceDelivered.$dirty) return errors;
      if (!serviceDelivered.required) errors.push('Service Delivered is Required.');
      return errors;
    },
    notAltService() {
      if(this.providerAbsent && (this.student.form.serviceInformation.absentAlternative === Constants.NOT_PROVIDED)) {
        return true;
      }
      else return false;
    },
    altService() {
      if(this.providerAbsent && (Constants.IS_ALT_SERVICE(this.student.form.serviceInformation.absentAlternative))) {
        return true;
      }
      else return false;
    }
  },
  mounted() {
    // if the action is edit or copy
    // set form values
    if (this.isEditingOrCopying) {
      const formValues = this.student.form.serviceInformation;
      // initialize date picker to passed in date
      this.serviceDate = moment(formValues.sessionDate, 'MM-DD-YYYY').format('YYYY-MM-DD')
      this.hideFields = Constants.IS_ABSENT(formValues.absentType);
      this.studentAbsent = Constants.IS_ABSENT_STU(formValues.absentType);
      this.providerAbsent = Constants.IS_ABSENT_PROVIDER(formValues.absentType);
      this.hideRoomField = formValues.deliveryMode !== Constants.IN_PERSON;
      this.hideProviderLocationField = formValues.deliveryMode !== Constants.TELEPRACTICE;
      this.showGroup = Constants.SHOW_GROUP_TYPE(formValues.groupType);
    }
    if (this.action === 'copy') {
      this.student.form.serviceInformation.sessionDate = '';
    }
  },
  methods: {
    absentTypeChanged(val) {
      this.v.absentType.$touch();
      this.hideFields = Constants.IS_ABSENT(val);
      this.studentAbsent = Constants.IS_ABSENT_STU(val);
      this.providerAbsent = Constants.IS_ABSENT_PROVIDER(val);
      if (val === undefined) {
        this.student.form.serviceInformation.absentType = null;
      }
      this.$emit('calculate:minutes');
    },
    groupTypeChanged(val) {
      this.showGroup = Constants.SHOW_GROUP_TYPE(val);
      if (!this.showGroup) this.student.form.serviceInformation.groupSize = 1;
    },
    serviceDeliveredChanged() {
      // recalculate reimbursable minutes
      this.v.serviceDelivered.$touch();
      this.$emit('calculate:minutes');
    },
    clearLocationsAutoComplete() {
      if (!this.student.form.serviceInformation.location) {
        this.locationsArray = [];
      }
    },
    allowedDates(date) {
      return moment(date).isBefore(moment());
    },
    startTimeChanged() {
      // close the modal
      this.startTimeModal = false;
      // mark the field as touched
      this.v.sessionTime.$touch();
      const startTime = this.student.form.serviceInformation.sessionTime;
      const endTime = this.student.form.serviceInformation.sessionTimeEnd;
      const elapsedTime = this.student.form.serviceInformation.sessionMinutes;
      if (startTime && endTime) {
        try {
          this.student.form.serviceInformation.sessionMinutes =
            utilityFunctions.calculateServiceLength(startTime, endTime);
          // set Service Length Field as touched for validations
          this.v.sessionMinutes.$touch();
        } catch (err) {
          // dont need to do anything with the error
        }
      } else if (startTime && elapsedTime) {
        try {
          this.student.form.serviceInformation.sessionTimeEnd =
            utilityFunctions.calculateEndTime(startTime, elapsedTime);
          // set End Time as touched for validations
          this.v.sessionTimeEnd.$touch();
        } catch (err) {
          // dont need to do anything with the error
        }
      }
    },
    endTimeChanged() {
      // close the modal
      this.endTimeModal = false;
      // mark the field as touched
      this.v.sessionTimeEnd.$touch();
      const startTime = this.student.form.serviceInformation.sessionTime;
      const endTime = this.student.form.serviceInformation.sessionTimeEnd;
      const elapsedTime = this.student.form.serviceInformation.sessionMinutes;
      if (startTime && endTime) {
        try {
          this.student.form.serviceInformation.sessionMinutes =
            utilityFunctions.calculateServiceLength(startTime, endTime);
          this.v.sessionMinutes.$touch();
        } catch (err) {
          // dont need to do anything with the error
        }
      } else if (endTime && elapsedTime) {
        try {
          this.student.form.serviceInformation.sessionTime =
            utilityFunctions.calculateStartTime(endTime, elapsedTime);
          this.v.sessionTime.$touch();
        } catch (err) {
          // dont need to do anything with the error
        }
      }
    },
    filterDisabledOptions(optionsArray, currVal) {
      let filteredOptions = [];
      optionsArray.forEach((option) => {
        if (!option.disabledFlag || option.value === currVal) filteredOptions.push(option);
      });
      return filteredOptions;
    },
    handleTextTrimming(field, value) {
      if (value !== null && value !== undefined) {
        const trimmed = value.trim();
        this.student.form.serviceInformation[field] = trimmed;
      }
    },
    handleTextTrimmingRequiredField(field, value) {
      this.v[field].$touch();
      if (value !== null && value !== undefined) {
        const trimmed = value.trim();
        this.student.form.serviceInformation[field] = trimmed;
      }
    },
    sessionMinutesChanged() {
      this.v.sessionMinutes.$touch();
      const serviceLength = this.student.form.serviceInformation.sessionMinutes;
      const startTime = this.student.form.serviceInformation.sessionTime;
      // const endTime = this.student.form.serviceInformation.sessionTimeEnd;
      if (startTime && serviceLength) {
        try {
          const calculatedEndTime = utilityFunctions.calculateEndTime(startTime, serviceLength);
          // set the value in the timepicker
          this.$refs.endTimeDialog.save(calculatedEndTime);
          this.student.form.serviceInformation.sessionTimeEnd = calculatedEndTime;
          this.v.sessionTimeEnd.$touch();
        } catch (err) {
          // dont need to do anything with the error
        }
      }
    },
    serviceDateChanged(val) {
      // mark field as touched for validation
      this.student.form.serviceInformation.sessionDate = utilityFunctions.formatDate(val);
      this.v.sessionDate.$touch();
    }
  },
  watch: {
    searchInput() {
      this.locationsLoading = true;
      clearTimeout(this.timeout);
      if (this.searchInput) {
        this.timeout = setTimeout(() => {
          api.get(Constants.GET_SERVICE_LOCATIONS_URL(this.searchInput))
            .then((res) => {
              this.locationsArray = res.data.data;
              this.locationsLoading = false;
            });
        }, 300);
      } else {
        this.locationsLoading = false;
      }
    },
    'student.form.serviceInformation.location': {
      handler(newVal, oldVal) {
        if (!newVal && oldVal) this.locationsArray = [];
        if (typeof newVal !== 'object') {
          this.student.form.serviceInformation.location = '';
        }
      }
    },
    'student.form.serviceInformation.deliveryMode': {
      handler(newVal) {
        this.hideRoomField = newVal !== Constants.IN_PERSON;
        this.hideProviderLocationField = newVal !== Constants.TELEPRACTICE;
      }
    },
    'student.form.serviceInformation.absentType': {
      handler(newVal, oldVal) {
        this.hideFields = Constants.IS_ABSENT(newVal);
        this.studentAbsent = Constants.IS_ABSENT_STU(newVal);
        this.providerAbsent = Constants.IS_ABSENT_PROVIDER(newVal);
        this.student.form.serviceInformation.absentReason = null;
        this.student.form.serviceInformation.absentAlternative = null;
      }
    },
    'student.form.serviceInformation.absentAlternative': {
      handler(newVal, oldVal) {
        this.student.form.serviceInformation.noServiceNotifFlag = null;
        this.student.form.serviceInformation.absentAlternativeDesc = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/service-log/form/service-information.vue